const firebaseConfig = {
  apiKey: "AIzaSyCn_lrRPHAU1DJwZPc8mdEjPRf-IvSpWiQ",
  authDomain: "medicare-home.firebaseapp.com",
  projectId: "medicare-home",
  storageBucket: "medicare-home.appspot.com",
  messagingSenderId: "918470108146",
  appId: "1:918470108146:web:85f1dc5d973beeacd6816b",
  measurementId: "G-3G26736KN6"
};



export default firebaseConfig;
